document.addEventListener('DOMContentLoaded', () => {
    function initMobileProductGalleries() {
        if (typeof window.jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') {
            return false;
        }

        const $ = window.jQuery;

        document.querySelectorAll('.pdp-main-product-container .product-mobile').forEach((wrapper) => {
            const $main = $(wrapper).find('.js-mobile-product-gallery').not('[data-featured-only="true"]');
            const thumbs = wrapper.querySelector('.js-mobile-product-thumbs');

            if (!$main.length) return;

            if (!$main.hasClass('slick-initialized')) {
                $main.slick({
                    dots: false,
                    arrows: false,
                    draggable: true,
                    swipe: true,
                    touchMove: true,
                    infinite: false,
                    initialSlide: 0,
                    adaptiveHeight: false,
                    speed: 250,
                });
            } else {
                $main.slick('setPosition');
            }

            if (!thumbs) return;

            const thumbButtons = thumbs.querySelectorAll('.product-mobile-thumbs__item');

            const scrollThumbIntoStrip = (btn) => {
                if (!btn || !thumbs) return;
                const left =
                    btn.offsetLeft - (thumbs.clientWidth - btn.offsetWidth) / 2;
                thumbs.scrollTo({
                    left: Math.max(0, left),
                    behavior: 'smooth',
                });
            };

            const setActiveThumb = (index) => {
                thumbButtons.forEach((btn) => {
                    const isActive = Number(btn.dataset.slideIndex) === index;
                    btn.classList.toggle('is-active', isActive);
                    if (isActive) scrollThumbIntoStrip(btn);
                });
            };

            // Horizontal drag/swipe scroll for the thumbnail strip
            if (thumbs.dataset.scrollBound !== 'true') {
                thumbs.dataset.scrollBound = 'true';
                let isPointerDown = false;
                let startX = 0;
                let startScrollLeft = 0;
                let moved = false;

                const onPointerDown = (event) => {
                    isPointerDown = true;
                    moved = false;
                    startX = event.pageX || event.touches?.[0]?.pageX || 0;
                    startScrollLeft = thumbs.scrollLeft;
                    thumbs.classList.add('is-dragging');
                };

                const onPointerMove = (event) => {
                    if (!isPointerDown) return;
                    const pageX = event.pageX || event.touches?.[0]?.pageX || 0;
                    const delta = pageX - startX;
                    if (Math.abs(delta) > 4) moved = true;
                    thumbs.scrollLeft = startScrollLeft - delta;
                    if (moved && event.cancelable) event.preventDefault();
                };

                const onPointerUp = () => {
                    isPointerDown = false;
                    thumbs.classList.remove('is-dragging');
                    thumbs.dataset.didDrag = moved ? 'true' : 'false';
                };

                thumbs.addEventListener('mousedown', onPointerDown);
                thumbs.addEventListener('mousemove', onPointerMove);
                thumbs.addEventListener('mouseup', onPointerUp);
                thumbs.addEventListener('mouseleave', onPointerUp);
                thumbs.addEventListener('touchstart', onPointerDown, { passive: true });
                thumbs.addEventListener('touchmove', onPointerMove, { passive: false });
                thumbs.addEventListener('touchend', onPointerUp);
            }

            thumbButtons.forEach((btn) => {
                if (btn.dataset.bound === 'true') return;
                btn.dataset.bound = 'true';
                btn.addEventListener('click', (event) => {
                    if (thumbs.dataset.didDrag === 'true') {
                        event.preventDefault();
                        return;
                    }
                    const index = Number(btn.dataset.slideIndex) || 0;
                    $main.slick('slickGoTo', index);
                    setActiveThumb(index);
                });
            });

            $main.off('afterChange.mobileThumbs').on('afterChange.mobileThumbs', (_event, _slick, currentSlide) => {
                setActiveThumb(currentSlide);
            });
        });

        return true;
    }

    function bootMobileGalleries(attemptsLeft) {
        if (initMobileProductGalleries()) return;
        if (attemptsLeft <= 0) return;
        setTimeout(() => bootMobileGalleries(attemptsLeft - 1), 100);
    }

    bootMobileGalleries(40);

    window.addEventListener('resize', () => {
        if (typeof window.jQuery === 'undefined' || typeof jQuery.fn.slick === 'undefined') return;
        jQuery('.js-mobile-product-gallery.slick-initialized').slick('setPosition');
    });

    document.addEventListener('shopify:section:load', () => bootMobileGalleries(20));

    const ratingsBlocks = document.querySelectorAll('#product-label .pdp-ratings-block, #product-label .pdp-ratings-container');
    ratingsBlocks.forEach((block) => {
        block.addEventListener('click', (e) => {
            e.preventDefault();

            const target = document.querySelector('.reviews-carousel-class');
            if (target) {
                target.scrollIntoView({ behavior: 'smooth' });
            }
        });
    });


    // Collapsible Content Functionality
    const toggleButtons = document.querySelectorAll('.pdp-main-product-container .collapsible-content__toggle');
    const answerContents = document.querySelectorAll('.pdp-main-product-container .collapsible-content__answer');

    toggleButtons.forEach((toggleButton, index) => {
        toggleButton.addEventListener('click', () => {
            answerContents.forEach((answerContent, i) => {
                if (i === index) {
                    return;
                }
                answerContent.classList.remove('active');

                const otherPlusIcon = toggleButtons[i].querySelector('.plus');
                const otherMinusIcon = toggleButtons[i].querySelector('.minus');

                if (otherPlusIcon) {
                    otherPlusIcon.style.display = 'block';
                }
                if (otherMinusIcon) {
                    otherMinusIcon.style.display = 'none';
                }
            });

            answerContents[index].classList.toggle('active');

            const plusIcon = toggleButton.querySelector('.plus');
            const minusIcon = toggleButton.querySelector('.minus');

            const isActive = answerContents[index].classList.contains('active');

            if (plusIcon) {
                plusIcon.style.display = isActive ? 'none' : 'block';
            }
            if (minusIcon) {
                minusIcon.style.display = isActive ? 'block' : 'none';
            }
        });
    });

    // Ratings Stars
    document.querySelectorAll('.ratings-stars .star-inner').forEach((element) => {
        element.style.width = `${(4.6 / 5) * 100}%`;
    });
    // const starInner = document.querySelector('.ratings-stars .star-inner');
    // if (starInner) {
    //     starInner.style.width = `${(4.5 / 5) * 100}%`;
    // }

    const videos = document.querySelectorAll('.product-video, .product-ugc-video');
    const muteButtons = document.querySelectorAll('.sound-button, .mute-unmute-button');

    function muteAllOtherVideos(currentVideo) {
        videos.forEach((video) => {
            if (video !== currentVideo) {
                video.muted = true;
                updateMuteIcons(video);
            }
        });
    }

    function updateMuteIcons(video) {
        let muteButton = video.nextElementSibling;
        if (!muteButton || !muteButton.classList.contains('mute-unmute-button')) {
            const parentContainer = video.closest('.half-width') || video.closest('.product__media-item');
            muteButton = parentContainer ? parentContainer.querySelector('.sound-button, .mute-unmute-button') : null;
        }

        if (!muteButton) return;

        const mobileIcons = {
            muteIcon: muteButton.querySelector('.mute-mobile-icon'),
            unmuteIcon: muteButton.querySelector('.unmute-mobile-icon'),
        };

        const desktopIcons = {
            muteIcon: muteButton.querySelector('.mute-icon'),
            unmuteIcon: muteButton.querySelector('.unmute-icon'),
        };

        const icons = mobileIcons.muteIcon ? mobileIcons : desktopIcons;

        if (video.muted) {
            if (icons.muteIcon) icons.muteIcon.style.display = 'block';
            if (icons.unmuteIcon) icons.unmuteIcon.style.display = 'none';
            muteButton.classList.add('mute');
            muteButton.classList.remove('unmute');
            return;
        }
        if (icons.muteIcon) icons.muteIcon.style.display = 'none';
        if (icons.unmuteIcon) icons.unmuteIcon.style.display = 'block';
        muteButton.classList.remove('mute');
        muteButton.classList.add('unmute');
    }

    function safeVideoPlay(video) {
        if (video?.play) {
            video.play().catch((error) => {
                if (error.name === 'AbortError') {
                    setTimeout(() => {
                        video.play().catch((retryError) => {
                            console.error('Retry failed:', retryError);
                        });
                    }, 100);
                } else {
                    console.error('Error playing video:', error);
                }
            });
        }
    }

    const videoObserver = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const video = entry.target;

                if (entry.isIntersecting) {
                    safeVideoPlay(video);
                } else {
                    video.pause();
                }

                if (!entry.isIntersecting && !video.muted) {
                    video.muted = true;
                    updateMuteIcons(video);
                }
            });
        },
        {
            root: null,
            rootMargin: '0px',
            threshold: 0.5,
        }
    );

    videos.forEach((video) => {
        video.muted = true;
        updateMuteIcons(video);
        videoObserver.observe(video);
    });

    muteButtons.forEach((button, index) => {
        button.addEventListener('click', function () {
            const video = videos[index];

            if (video.muted) {
                video.muted = false;
                muteAllOtherVideos(video);
            } else {
                video.muted = true;
            }

            updateMuteIcons(video);
        });
    });

    const modal = document.getElementById('pdp-media-modal');
    if (!modal) {
        console.error('Modal not found');
        return;
    }

    const modalClose = modal.querySelector('.pdp-media-modal-close');
    const modalImage = modal.querySelector('img.pdp-modal-content');
    const modalVideo = modal.querySelector('video.pdp-modal-content');

    if (!modalClose || !modalImage || !modalVideo) {
        console.error('One or more modal elements are missing', {
            modalClose: !!modalClose,
            modalImage: !!modalImage,
            modalVideo: !!modalVideo,
        });
        return;
    }

    const modalVideoSource = modalVideo.querySelector('source');
    if (!modalVideoSource) {
        console.error('Modal video source not found');
        return;
    }

    const mediaElements = document.querySelectorAll('.grid-container img, .grid-container video');

    function openModal(media) {
        try {
            modalImage.style.display = 'none';
            modalVideo.style.display = 'none';

            if (media.tagName.toLowerCase() === 'img') {
                const imageSrc = media.dataset.src || media.src;

                const tempImg = new Image();
                tempImg.onload = function () {
                    modalImage.src = imageSrc;
                    modalImage.style.display = 'block';
                };
                tempImg.src = imageSrc;
            } else if (media.tagName.toLowerCase() === 'video') {
                const sourceElement = media.querySelector('source');
                if (!sourceElement) {
                    console.error('No source element found in video');
                    return;
                }

                const videoSrc = sourceElement.dataset.src || sourceElement.src;

                modalVideo.pause();
                modalVideo.currentTime = 0;

                modalVideoSource.src = videoSrc;
                modalVideo.load();

                modalVideo.onloadedmetadata = () => {
                    modalVideo.muted = false;
                    safeVideoPlay(modalVideo);
                    modalVideo.style.display = 'block';
                };
            }

            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';
        } catch (error) {
            console.error('Error opening modal:', error);
        }

        // To handle z-index when the model is opened
        document.querySelector('.header-class').style.zIndex = '1';
        document.querySelector('.announcement-bar-class').style.zIndex = '1';
    }

    // Function to close modal
    function closeModal() {
        try {
            modal.style.display = 'none';
            document.body.style.overflow = 'auto';

            if (modalVideo.style.display !== 'none') {
                modalVideo.pause();
                modalVideo.currentTime = 0;
                modalVideo.muted = true;
            }
        } catch (error) {
            console.error('Error closing modal:', error);
        }

        // To handle z-index when the model is closed
        document.querySelector('.header-class').style.zIndex = '8';
        document.querySelector('.announcement-bar-class').style.zIndex = '9';
    }

    mediaElements.forEach((media) => {
        media.addEventListener('click', function () {
            openModal(this);
        });
    });

    modalClose.addEventListener('click', closeModal);

    modal.addEventListener('click', function (event) {
        if (event.target === modal) {
            closeModal();
        }
    });


    // Proofs/Stats Containers
    const statsContainers = document.querySelectorAll('.pdp-proofs .pdp-proofs-stats');

    if (statsContainers.length === 1) {
        const pdpProofs = document.querySelector('.pdp-main-product-container .pdp-proofs');
        if (pdpProofs) {
            pdpProofs.classList.add('single');
        }
        statsContainers[0].style.display = 'flex';
        return;
    }
    if (statsContainers.length !== 2) {
        return;
    }
    statsContainers[0].classList.add('active');

    function autoChange() {
        const currentNote = document.querySelector('.pdp-proofs .pdp-proofs-stats.active');
        const nextNote = currentNote ? currentNote.nextElementSibling : null;

        if (nextNote?.classList.contains('pdp-proofs-stats')) {
            currentNote.classList.remove('active');
            nextNote.classList.add('active');
            return;
        }
        if (currentNote) {
            currentNote.classList.remove('active');
        }
        const firstStats = document.querySelector('.pdp-proofs .pdp-proofs-stats');
        if (firstStats) {
            firstStats.classList.add('active');
        }
    }

    setInterval(() => {
        autoChange();
    }, 5000);


    const pairsTitle = document.getElementById("pairs-well-with-title");
    const kitsTitle = document.getElementById("save-with-kits-title");
    const pairsProduct = document.getElementById("pairs-well-with-product");
    const kitsProduct = document.getElementById("save-with-kits-product");

    function setActive(tab) {
        if (tab === "pairs") {
            pairsTitle.classList.add("active");
            kitsTitle.classList.remove("active");
            pairsProduct.classList.add("active");
            kitsProduct.classList.remove("active");
        } else {
            kitsTitle.classList.add("active");
            pairsTitle.classList.remove("active");
            kitsProduct.classList.add("active");
            pairsProduct.classList.remove("active");
        }
    }

    setActive("kits");

    pairsTitle.addEventListener("click", () => setActive("pairs"));
    kitsTitle.addEventListener("click", () => setActive("kits"));


});